import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "form"
}
const _hoisted_3 = { class: "fieldset" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_6 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_7 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_8 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_9 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_10 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "item" }
const _hoisted_13 = { for: "IsPrivacyPolicy" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "calltoaction full" }
const _hoisted_18 = {
  key: 1,
  class: "success"
}

import { ref, onBeforeMount } from "vue";
import axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import FormHelper from "@Scripts/Common/FormHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoRequest',
  props: {
    recaptchaSiteKey: {},
    originPage: {}
  },
  setup(__props: any) {

const props = __props;

const routes = (window as any).App.routes;

const isLoading = ref<boolean>(false);
const isSuccess = ref<boolean>(false);
const isPrivacyPolicyShow = ref<boolean>(false);
const privacyPolicy = ref<string | null>(null);
const formData = ref<any>({ zone: null });
const validationErrors = ref<any[]>([]);
const provinces = ref<any[]>([]);

onBeforeMount(async () => {
    const result = (await axios.post(routes.SoleDiCasa_GetInfoRequestData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    privacyPolicy.value = Object.freeze(result.privacyPolicy);
    provinces.value = result.provinces;
});

async function showPrivacyPolicy() {
    isPrivacyPolicyShow.value = !isPrivacyPolicyShow.value;
}

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoading.value = true;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: "Submit" });
        try {
            await axios.post(routes.SoleDiCasa_InfoRequestSubmit, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken(), "RecaptchaVerificationToken": token } });

            isSuccess.value = true;

            GTagHelper.sendEvent("form_submit", "soledicasa_info_request");
            (window as any).gtag("event", "conversion", { "send_to": "AW-412883659/fCJGCO62-J0ZEMu18MQB" });
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }
    });

    isLoading.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isSuccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("fieldset", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass([{ 'input-validation-error': isValidationError('IsIndipendentHouse') }, 'checkbox'])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "IsIndipendentHouse",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.isIndipendentHouse) = $event))
                }, null, 512), [
                  [_vModelCheckbox, formData.value.isIndipendentHouse]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("label", { for: "IsIndipendentHouse" }, "Conferma che la tua abitazione è indipendente", -1))
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                class: "label",
                for: "Name"
              }, "Nome", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "Name",
                id: "Name",
                "aria-label": "Nome",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.name) = $event)),
                class: _normalizeClass([{ 'input-validation-error': isValidationError('Name') }, 'textbox'])
              }, null, 2), [
                [
                  _vModelText,
                  formData.value.name,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[12] || (_cache[12] = _createElementVNode("label", {
                class: "label",
                for: "Surname"
              }, "Cognome", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "Surname",
                id: "Surname",
                "aria-label": "Cognome",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.surname) = $event)),
                class: _normalizeClass([{ 'input-validation-error': isValidationError('Surname') }, 'textbox'])
              }, null, 2), [
                [
                  _vModelText,
                  formData.value.surname,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[13] || (_cache[13] = _createElementVNode("label", {
                class: "label",
                for: "Phone"
              }, "Telefono", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "Phone",
                id: "Phone",
                "aria-label": "Telefono",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.phone) = $event)),
                class: _normalizeClass([{ 'input-validation-error': isValidationError('Phone') }, 'textbox'])
              }, null, 2), [
                [
                  _vModelText,
                  formData.value.phone,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[14] || (_cache[14] = _createElementVNode("label", {
                class: "label",
                for: "Email"
              }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "Email",
                id: "Email",
                "aria-label": "Email",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.email) = $event)),
                class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'textbox'])
              }, null, 2), [
                [
                  _vModelText,
                  formData.value.email,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[15] || (_cache[15] = _createElementVNode("label", {
                class: "label",
                for: "City"
              }, "Città", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "City",
                id: "City",
                "aria-label": "Città",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.city) = $event)),
                class: _normalizeClass([{ 'input-validation-error': isValidationError('City') }, 'textbox'])
              }, null, 2), [
                [
                  _vModelText,
                  formData.value.city,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                class: "label",
                for: "Zone"
              }, "Provincia", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "Zone",
                "aria-label": "Provincia",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.zone) = $event)),
                class: _normalizeClass([{ 'input-validation-error': isValidationError('Zone') }, 'dropdown'])
              }, [
                _cache[16] || (_cache[16] = _createElementVNode("option", { value: null }, "...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinces.value, (zone, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: zone.value,
                    key: index
                  }, _toDisplayString(zone.title), 9, _hoisted_11))
                }), 128))
              ], 2), [
                [
                  _vModelSelect,
                  formData.value.zone,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: _normalizeClass([{ 'input-validation-error': isValidationError('IsPrivacyPolicy') }, 'checkbox'])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "IsPrivacyPolicy",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.IsPrivacyPolicy) = $event))
                }, null, 512), [
                  [_vModelCheckbox, formData.value.IsPrivacyPolicy]
                ]),
                _createElementVNode("label", _hoisted_13, [
                  _createElementVNode("span", {
                    class: "disclaimer",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (showPrivacyPolicy()))
                  }, [
                    _cache[18] || (_cache[18] = _createTextVNode("Confermo di aver letto la ", -1)),
                    _createElementVNode("a", {
                      href: _unref(routes).UrlPolicyInfoRequest,
                      rel: "noreferrer",
                      target: "_blank",
                      class: "button-privacy",
                      "aria-label": "Beghelli.it - Privacy policy"
                    }, "Privacy Policy", 8, _hoisted_14)
                  ])
                ])
              ], 2)
            ]),
            (validationErrors.value.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  id: "ButtonSubmit",
                  class: "button full",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (submitForm()))
                }, "Invia")
              ])
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "item" }, [
              _createElementVNode("div", { class: "grecaptcha-terms" }, [
                _createTextVNode("Questo sito è protetto da reCAPTCHA e si applicano la "),
                _createElementVNode("a", {
                  href: "https://policies.google.com/privacy",
                  target: "_blank",
                  "aria-label": "Google privacy",
                  rel: "noopener"
                }, "Normativa sulla privacy"),
                _createTextVNode(" e i "),
                _createElementVNode("a", {
                  href: "https://policies.google.com/terms",
                  target: "_blank",
                  "aria-label": "Google terms",
                  rel: "noopener"
                }, "Termini di servizio"),
                _createTextVNode(" di Google.")
              ])
            ], -1))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[20] || (_cache[20] = [
          _createStaticVNode("<div class=\"content\"><div class=\"maintitle s35\"><img src=\"/areas/soledicasa/images/check.svg\" width=\"21\" height=\"18\" alt=\"Check\" class=\"check\">Richiesta inviata!</div></div><div class=\"maintitle s24 upper\"> Sarai ricontattato al più presto <div class=\"underline\"></div></div><div class=\"download\"><div class=\"maintitle s22 white\"> Leggi il nostro kit informativo </div><div class=\"calltoaction\"><a href=\"/media/soledicasa/Beghelli Sole di Casa - Kit Informativo.pdf\" class=\"button\">Scarica subito!</a></div></div>", 3)
        ]))]))
  ]))
}
}

})